import React from 'react';

import Search from '@components/search/Search.tsx';

import I from '../types.ts';

const renderSearch: I['renderSearch'] = function () {
    const { search = '' } = this.state;

    return (
        <div className="publicBlog__headSearch">
            <Search
                value={search}
                className="_grey _public"
                support="Введите название статьи"
                onChange={this.searchHandler.bind(this)}
            />
        </div>
    );
};

export default renderSearch;
